import _regenerator from "/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  name: 'App',
  provide: function provide() {
    return {
      app: this,
      formulario: ''
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.$store.dispatch('app/getLocation');
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  }
};